import type { ContactFormFieldName, ContactFormPayload } from '@/features/contact/model/contactFormSchema'

export type ContactFormSubmitResult =
  | {
      ok: true
    }
  | {
      code?: string
      error?: string
      fieldErrors?: Partial<Record<ContactFormFieldName, string>>
      ok: false
    }

export async function submitContactForm(payload: ContactFormPayload): Promise<ContactFormSubmitResult> {
  try {
    const response = await fetch('/api/contact', {
      body: JSON.stringify(payload),
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
    })

    const data = (await response.json().catch(() => null)) as {
      code?: string
      error?: string
      fieldErrors?: Partial<Record<ContactFormFieldName, string>>
    } | null

    if (!response.ok) {
      return {
        code: data?.code,
        error: data?.error,
        fieldErrors: data?.fieldErrors,
        ok: false,
      }
    }

    return { ok: true }
  } catch {
    return {
      error: undefined,
      ok: false,
    }
  }
}
